// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zGQVr","title":"styles_title__tr4Do","body_loading":"styles_body_loading__1UPc7"};